import React, { useState } from "react";
import { Container } from "react-bootstrap";
import * as s from "./index.module.scss";
import { PrismicRichText } from "@prismicio/react";
import secondaryFont from "@/utils/secondaryFont";
import Link from "next/link";

const Resources = ({ data }) => {
  const [activeResource, setActiveResource] = useState(0);
  return (
    <section className={`section-center ${s.resources}`}>
      <Container>
        <div>
          <h2 className="text-center title fw-bold">
            {data?.title || "Blogs"}
          </h2>

          <article>
            <div className={`${s.image_container} ${s.desktop_image}`}>
              {data?.data?.map((item, idx) => {
                return (
                  <img
                    loading="lazy"
                    className={
                      activeResource === idx ? s.show_resource_image : ""
                    }
                    key={idx}
                    src={item.data.image?.url}
                    alt={item.data.image?.alt || ""}
                  />
                );
              })}
              <div>
                {data?.data?.map((item, idx) => {
                  return (
                    <h3
                      className={`heading ${
                        activeResource === idx ? s.show_resource : ""
                      }`}
                      key={idx}
                    >
                      {item.data.title}
                    </h3>
                  );
                })}
              </div>
            </div>

            <div className={s.desktop_version}>
              {data?.data?.map((item, idx) => {
                return (
                  <Link
                    href={`/blogs/${item.uid}`}
                    key={idx}
                    className={s.single_resource}
                    onMouseOver={() => {
                      setActiveResource(idx);
                    }}
                  >
                    <>
                      <div
                        className={`${s.hover_box} ${s.desktop_image} ${
                          activeResource === idx ? s.show_resource : ""
                        }`}
                      ></div>
                      <img
                        loading="lazy"
                        src={item.data.image?.url}
                        alt={item.data.image?.alt || "image"}
                        className={`${s.mobile_image} mb-2`}
                      />
                      <div className="d-flex justify-content-start align-items-start">
                        <h4>{item.data.title}</h4>
                      </div>
                      <div className={`${secondaryFont} caption`}>
                        <PrismicRichText field={item.data.excerpt} />
                      </div>
                    </>
                  </Link>
                );
              })}
            </div>
          </article>
        </div>
      </Container>
    </section>
  );
};

export default Resources;
